<template>
  <object width="100%" style="height:100vh;" type="application/pdf" data="https://oxoformdocs.fra1.digitaloceanspaces.com/haier_2021TF1/invoice-1613558666723-9391.pdf">
    <p>Insert your error message here, if the PDF cannot be displayed.</p>
</object>
</template>
<script>
var consts = require('../config');
import axios from "axios";

export default {
  name: "form",
  data: function () {
    return {
      step: 0,
      form_id: consts.FORM_ID,
      server: consts.SERVER_URL,
    };
  },
  methods: {
    
  },
  mounted() {
  },
  created: function () {}
} 
</script>